var map = {
	"./arrow-right1.png": "f156",
	"./arrow-right2.png": "641d",
	"./banner_about.png": "cea2",
	"./banner_contact.png": "2f3a0",
	"./banner_index.png": "e7ed",
	"./banner_product.png": "0ffa",
	"./banner_solution.png": "9b7f",
	"./banner_support.png": "4685",
	"./code.png": "f45d",
	"./icon_email.png": "90de",
	"./icon_left.png": "82ee",
	"./icon_qq.png": "1c2b",
	"./icon_right.png": "13c0",
	"./icon_right2.png": "15a0",
	"./icon_right3.png": "ad1e",
	"./icon_weixin.png": "5fe3",
	"./img_about1.png": "87d7",
	"./img_about2.png": "f69c",
	"./img_business.png": "1fff",
	"./img_business10.png": "74ae",
	"./img_business11.png": "ce19",
	"./img_business12.png": "8f46",
	"./img_business2.png": "1089",
	"./img_business3.png": "d43a",
	"./img_business4.png": "712b",
	"./img_business5.png": "913c",
	"./img_business6.png": "3038",
	"./img_business7.png": "872b",
	"./img_business8.png": "fb06",
	"./img_business9.png": "4a4b",
	"./img_news.png": "1c05",
	"./img_news1.png": "1efa",
	"./img_news2.png": "64ec",
	"./img_news3.png": "6a14",
	"./img_news4.png": "78ae",
	"./img_product1.png": "5415",
	"./img_product10.png": "7de7",
	"./img_product11.png": "f3d4",
	"./img_product12.png": "6474",
	"./img_product2.png": "26f5",
	"./img_product3.png": "28a8",
	"./img_product4.png": "7870",
	"./img_product5.png": "2b81",
	"./img_product6.png": "9307",
	"./img_product7.png": "9101",
	"./img_product8.png": "ef3e",
	"./img_product9.png": "6ee8",
	"./img_support.png": "49a1",
	"./logo.png": "4ffd",
	"./logo2.png": "440d",
	"./logo3.png": "7cbd",
	"./solution/detail1.png": "cb17",
	"./solution/detail2.png": "9cb5",
	"./solution/detail3.png": "6b94",
	"./solution/detail4.png": "1c48",
	"./solution/detail5.png": "1020",
	"./solution/img1.png": "41fa",
	"./solution/img2.png": "c92e",
	"./solution/img3.png": "4cfd",
	"./solution/img4.png": "3019",
	"./solution/img5.png": "498f",
	"./solution/img_solution1.png": "43e7",
	"./solution/img_solution2.png": "dc2f",
	"./solution/img_solution3.png": "0516",
	"./solution/img_solution4.png": "7226",
	"./solution/img_solution5.png": "cc36",
	"./solution/solution1.png": "2f3a",
	"./solution/solution2.png": "2fca",
	"./solution/solution3.png": "9dda",
	"./solution/solution4.png": "0c98",
	"./solution/solution5.png": "1509"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";